const API_KEY = process.env.REACT_APP_CONVERTKIT_API_KEY;
const VALIDATE_FORM_ID = process.env.REACT_APP_VALIDATE_FORM_ID;
const GETTING_STARTED_FORM_ID = process.env.REACT_APP_GETTING_STARTED_FORM_ID;

interface ConvertKitSubscribeResponse {
  subscription: {
    id: number;
    state: string;
    created_at: string;
    subscriber: {
      id: number;
      email_address: string;
    };
  };
}

export async function subscribeToConvertKit(
  email: string,
  mode: 'validate' | 'gettingStarted',
  customFields?: Record<string, any>
): Promise<ConvertKitSubscribeResponse> {

  if (!email || !email.includes('@')) {
    throw new Error('Invalid email address');
  }

  if (!API_KEY || !VALIDATE_FORM_ID || !GETTING_STARTED_FORM_ID) {
    throw new Error('ConvertKit credentials not configured');
  }

  const formId = mode === 'validate' ? VALIDATE_FORM_ID : GETTING_STARTED_FORM_ID;

  const requestBody = {
    api_key: API_KEY,
    email: email,
    fields: customFields || {},
  };

  const response = await fetch(
    `https://api.convertkit.com/v3/forms/${formId}/subscribe`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    }
  );

  if (!response.ok) {
    const errorText = await response.text();
    console.error('ConvertKit API error:', errorText);
    throw new Error(`Failed to subscribe: ${response.status}`);
  }

  return response.json();
}
